var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-page',{attrs:{"breadcrumb":_vm.$route.meta.breadcrumb,"errors":_vm.errors,"loading":_vm.loading,"navbutton":_vm.navbuttonEnabled && _vm.$route.meta.navbutton,"sidebar-enabled":_vm.$route.meta.sidebar.enabled,"vars":_vm.queryParams,"on-discard-alert":_vm.handleDiscardAlert}})
}
var staticRenderFns = []

export { render, staticRenderFns }